"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopFrameImage = require("./TopFrameImage");
Object.keys(_TopFrameImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopFrameImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopFrameImage[key];
    }
  });
});
